module.exports = __webpack_public_path__ + "img/Pakistan.ac9eb89a.png";